module.exports = __webpack_public_path__ + "img/red-marker.298e6f72.svg";